class Parallax {
    constructor() {
        let $section = document.querySelectorAll('.js-parallax');
        if($section.length === null) {
            return;
        }
        let margin = (window.UA.isSP)? 80: 80;
        let offset = (window.UA.isSP)? 360: 250;
        let stop = (window.UA.isSP)? 17: 52;
        let controller = new ScrollMagic.Controller();
        // window.scrollController.push(controller);
        for(let i = 0; i < $section.length; i++) {
            let scene = new ScrollMagic.Scene({
                triggerElement: $section[i],
                triggerHook: 'onEnter',
                // reverse: true,
                offset: offset,
                duration: window.innerHeight+300
            })
                //.addIndicators({name: '____HRERE333'}) // add indicators (requires plugin)
                .addTo(controller);
            scene.on('progress', (e)=>{
                // console.log(e.progress);
                let y = parseInt(e.progress*margin);
                if(y > stop) {
                    y = stop;
                }
                if($($section[i]).hasClass('is-reverse')) {
                    $($section[i]).css({
                        transform: `translate3d(0, ${y}px, 0)`
                    });
                } else {
                    $($section[i]).css({
                        transform: `translate3d(0, -${y}px, 0)`
                    });
                }
                
            });
        }
    }
}

export default Parallax;
